// extracted by mini-css-extract-plugin
module.exports =  {"card":"GroupCard-HS2P__card","header":"GroupCard-QkpU__header","no-image":"GroupCard-qrQT__no-image","list":"GroupCard-dDIe__list"};